var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
document.addEventListener("DOMContentLoaded", () => {
  const target = document.getElementById("participatory-process-group-homepage-calendar");
  let filters = JSON.parse(decodeURIComponent(target.dataset.resources));
  const removeFilter = (filterArray, filter) => {
    return filterArray.filter((element) => element !== filter);
  };
  const events = JSON.parse(decodeURIComponent(target.dataset.events)).map((event, index) => __spreadValues({
    id: index + 1
  }, event));
  const calendarEl = document.getElementById("calendar");
  const calendar = new Calendar(calendarEl, {
    plugins: [timeGridPlugin, dayGridPlugin],
    locale: "es",
    height: "auto",
    eventTimeFormat: {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      omitZeroMinute: false
    },
    events
  });
  const getCurrentEventsIds = () => {
    return calendar.getEvents().map((event) => event.id);
  };
  const filterEvents = (initialEvents) => {
    const currentEventsIds = getCurrentEventsIds();
    const currentEvents = calendar.getEvents();
    initialEvents.forEach((event) => {
      if (filters.includes(event._def.extendedProps.resourceId) && !currentEventsIds.includes(event.id)) {
        calendar.addEvent(event);
      }
    });
    const eventsToRemove = currentEvents.filter(
      (event) => !filters.includes(event._def.extendedProps.resourceId)
    ).map((event) => event.id);
    eventsToRemove.forEach((eventId) => {
      const event = calendar.getEventById(eventId);
      if (event) {
        event.remove();
      }
    });
  };
  const initializeCalendar = () => {
    calendar.setOption("locale", target.dataset.locale);
    calendar.render();
    const initialEvents = calendar.getEvents();
    document.querySelectorAll(".cal-filter").forEach((filterButton) => {
      filterButton.addEventListener("click", function() {
        this.classList.toggle("hollow");
        let filter = this.id;
        if (filters.includes(filter)) {
          filters = removeFilter(filters, filter);
        } else {
          filters.push(filter);
        }
        filterEvents(initialEvents);
      });
    });
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeCalendar);
  } else {
    initializeCalendar();
  }
});
